import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

// COMPONENTI
import { Helmet } from "react-helmet";
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";

// HOOKS
import useInViewAnimation from "../../hooks/utilityStyle/useInViewAnimation";


const PropertyPromotion: React.FC = () => {

    const { t } = useTranslation();

    const [pageReady, setPageReady] = useState(false);
    useEffect(() => {
        // Questo set time out è divuto al video che falsa lo posizione degli elemnti nel DOM finche non carica
        const timer = setTimeout(() => { 
            setPageReady(true);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    const ref1 = useRef<HTMLHeadingElement>(null);
    const ref2 = useRef<HTMLParagraphElement>(null);
    const ref3 = useRef<HTMLParagraphElement>(null);
    const ref4 = useRef<HTMLParagraphElement>(null);
    const ref5 = useRef<HTMLParagraphElement>(null);
    const ref6 = useRef<HTMLParagraphElement>(null);
    const ref7 = useRef<HTMLParagraphElement>(null);
    const ref8 = useRef<HTMLParagraphElement>(null);
    const ref9 = useRef<HTMLParagraphElement>(null);
    const ref10 = useRef<HTMLParagraphElement>(null);
    const allRefs: React.RefObject<HTMLHeadingElement | HTMLParagraphElement | null>[] = [ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10];
    useInViewAnimation({animationElementsRef: allRefs, animationClass: 'fade-in', pageReady: pageReady});

    const promotionList = [
        {
            title: t("promotionPage.promo1.title"),
            description: t("promotionPage.promo1.description"),
        },
        {
            title: t("promotionPage.promo2.title"),
            description: t("promotionPage.promo2.description"),
        },
        {
            title: t("promotionPage.promo3.title"),
            description: t("promotionPage.promo3.description"),
        },  
        {
            title: t("promotionPage.promo4.title"),
            description: t("promotionPage.promo4.description"),
        },
        {
            title: t("promotionPage.promo5.title"),
            description: t("promotionPage.promo5.description"),
        },
        {
            title: t("promotionPage.promo6.title"),
            description: t("promotionPage.promo6.description"),
        },
        {
            title: t("promotionPage.promo7.title"),
            description: t("promotionPage.promo7.description"),
        },
        {
            title: t("promotionPage.promo8.title"),
            description: t("promotionPage.promo8.description"),
        },
        {
            title: t("promotionPage.promo9.title"),
            description: t("promotionPage.promo9.description"),
        },
        {
            title: t("promotionPage.promo10.title"),
            description: t("promotionPage.promo10.description"),
        }
    ];
    
    return (
        <>
            <Helmet>
                <title>{t("promotionPage.pageTitle")}</title>
                <meta name="description" content={t("promotionPage.metaDescription") as string} />    
            </Helmet>

            <SubHeaderDefault title={t("promotionPage.pageTitle") as string} isSeo={true} />

            <main id="promotion-page" className="space-ptb bg-custom">
                <div className="container-fluid w-special">
                    <h2 className="mb-4">{t("promotionPage.title")}</h2>
                    <p className="mb-5" dangerouslySetInnerHTML={{ __html: t("promotionPage.para1") as string }}></p>
                    <div className="row">
                        {promotionList.map((promo, index) => (
                            <div key={index} className="col-12 col-lg-6" ref={allRefs[index]}>
                                <div className="mb-4 promo-wrapper">
                                    <h4>{promo.title}</h4>
                                    <p>{promo.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </main>
        </>
    );
};

export default PropertyPromotion;